import { Flex } from "@chakra-ui/react";

export default function MenuItem({ ...rest }) {
  return (
    <Flex
      alignItems="center"
      height="40px"
      transition="background 300ms"
      pl="16px"
      cursor="pointer"
      _hover={{
        bg: "hover"
      }}
      {...rest}
    ></Flex>
  );
}
